export const VOTING_ROOM_ROUTE_PATH = "/session/:invitation_code";
export const LEGAL_NOTICES_ROUTE_PATH = "/legal-notices";
